import {
    type ContactEmailBounceFields,
    getActiveContactEmailBounce,
} from '@common/utils/contactEmailBounce';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Chip, Tooltip } from '@mui/material';

interface Props {
    contact: ContactEmailBounceFields | null | undefined;
}

export default function ContactEmailBounceChip({ contact }: Props) {
    const bounce = getActiveContactEmailBounce(contact);
    if (!bounce) return null;

    return (
        <Tooltip title={bounce.reason ?? 'The intake email could not be delivered'}>
            <Chip
                size="small"
                color="error"
                variant="outlined"
                icon={<ErrorOutlineIcon />}
                label="Email bounced"
            />
        </Tooltip>
    );
}
